export default __webpack_public_path__ + "142e2b0350b3e9f7b6d1dc78110a4798.webp";